// src/environment/environment.prod.js
const environment = {
    API_URL: "http://localhost:9090/",
}

export default environment;
